/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    CONFIRM_POLL_RESPONSE: 'Confirmar respuesta',
    CONTINUE: 'Continuar',
    COPY: 'Copiar',
    DELETE: 'Eliminar',
    DELETE_MESSAGE: 'Eliminar mensaje',
    EDIT: 'Editar',
    FINISH: 'Finalizar',
    HIDE_ANSWERS: 'Ocultar respuestas',
    LETS_GET_STARTED: 'Claro, vamos empezar.',
    MARK_AS_UNREAD: 'Marcar como no leído',
    REPLY: 'Responder',
    SEE_ANSWERS: 'Ver respuestas',
    START_SURVEY: 'Iniciar encuesta'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'El tamaño máximo de un archivo es {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'La encuesta expiró porque ya existe una campaña para esta categoría.',
    ERROR_CREATING_NEW_SUGGESTION: 'Error al crear una nueva oferta',
    ERROR_SAVING_PRODUCT_REVIEW: 'Error al guardar la valoración del producto',
    ERROR_SENDING_MESSAGE: 'Error al enviar el mensaje',
    ERROR_SUBMITTING_SURVEY: 'Error al enviar la encuesta',
    IMAGE_SIZE_EXCEEDED: 'El tamaño máximo de una imagen es {size}MB',
    MESSAGE_ALREADY_READ:
      'Este mensaje ya no se puede editar porque ya ha sido leído.',
    UPLOADED_ASSETS_EXCEED: 'El número máximo de archivos es {limit}',
    VIDEO_SIZE_EXCEEDED: 'El tamaño máximo de un vídeo es {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Acciones',
    ADDITIONAL_COMMENTS_QUESTION: '¿Algún comentario adicional?',
    ANSWERED_ON: 'Respondido a {date}',
    CONTACT_OWNER: 'Algo salió mal. Por favor, contacta a tu gerente',
    CREATE_NEW_CAMPAIGN_SUGGESTION:
      'Haz clic aquí para generar una nueva oferta',
    EDITED: 'Editado',
    EXPIRED_ON: 'Ha caducado el {date}',
    LAST_READ: 'Última lectura',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Oferta caducada',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ Al aceptar, la campaña se creará y comenzará mañana.\nMañana también recibirás el mensaje con el cartel para compartir.\nEsta oferta estará disponible durante 3 días.',
    QUANTITY: 'Cantidad',
    REACT: 'Reaccionar',
    REACTIONS: 'Reacciones',
    RESPOND_BY: 'Responder hasta {date}',
    SEE_PRODUCTS: 'Ver productos',
    SEEN: 'Visto',
    SELECT_ADDRESS: 'Seleccionar dirección',
    SELECT_ONE_OPTION: 'Selecciona una opción',
    SELECT_ONE_OR_MORE_OPTION: 'Selecciona una o más opciones',
    SENT: 'Enviado',
    SWIPE_TO_CANCEL: 'Deslizar para cancelar',
    TYPE_NEW_MESSAGE: 'Escribe un nuevo mensaje',
    VOICE_MESSAGE: 'Mensaje de voz'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Esta acción confirmará el pedido y no será posible modificar la respuesta. ¿Seguro que desea continuar?',
    DELETE_MESSAGE_CONFIRM:
      '¿Estás seguro de que quieres eliminar este mensaje?',
    GIVE_OPINION_ABOUT_PRODUCT:
      '¿Podrías darnos tu opinión sobre este producto?',
    MESSAGE_DELETED: 'Este mensaje ha sido eliminado'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
